"use client"
/* */
import { isFlowComponentName } from './isFlowComponentName.mjs';

function isFlowComponentProp(something) {
  return !isFlowComponentName(something);
}

export { isFlowComponentProp };
//# sourceMappingURL=isFlowComponentProp.mjs.map
